(() => {
  if (!customElements.get('tone-content-reviews')) {
    customElements.define('tone-content-reviews', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.items = Array.from(this.querySelectorAll('[data-review]'));
        this.pageSize = Math.max(1, Number(this.dataset.perPage) || 3);
        this.limit = this.pageSize;
        this.filter = 'all';
        this.querySelector('[data-review-filters]')?.removeAttribute('hidden');
        this.addEventListener('click', (event) => {
          const filter = event.target.closest('[data-review-filter]');
          if (filter && this.contains(filter)) {
            this.filter = filter.dataset.reviewFilter;
            this.limit = this.pageSize;
            this.querySelectorAll('[data-review-filter]').forEach(button => {
              button.setAttribute('aria-pressed', String(button === filter));
            });
            this.render();
          }
          if (event.target.closest('[data-review-more]')) {
            const previousLimit = this.limit;
            this.limit += this.pageSize;
            const matches = this.render();
            matches[previousLimit]?.focus({preventScroll: true});
          }
        }, {signal: this.controller.signal});
        this.render();
      }
      render() {
        const matches = this.items.filter(item => this.filter === 'all' || item.dataset.rating === this.filter);
        const visible = new Set(matches.slice(0, this.limit));
        this.items.forEach(item => { item.hidden = !visible.has(item); });
        const more = this.querySelector('[data-review-more]');
        if (more) more.hidden = matches.length <= this.limit;
        const empty = this.querySelector('[data-review-empty]');
        if (empty) empty.hidden = matches.length > 0;
        const status = this.querySelector('[data-review-status]');
        if (status) status.textContent = (this.dataset.status || '').replace('[visible]', visible.size).replace('[count]', matches.length);
        return matches;
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  if (!customElements.get('tone-content-related')) {
    customElements.define('tone-content-related', class extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.url || this.loaded) return;
        this.controller?.abort();
        this.controller = new AbortController();
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
              this.observer.disconnect();
              this.load();
            }
          }, {rootMargin: '200px 0px'});
          this.observer.observe(this);
        } else this.load();
      }
      async load() {
        if (this.loading || this.loaded) return;
        const controller = this.controller;
        this.loading = true;
        try {
          const url = new URL(this.dataset.url, window.location.origin);
          if (url.origin !== window.location.origin) return;
          const response = await fetch(url, {signal: controller.signal, credentials: 'same-origin', headers: {'Accept': 'text/html'}});
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const replacement = Array.from(html.querySelectorAll('tone-content-related')).find(element => element.dataset.sectionId === this.dataset.sectionId);
          if (!replacement || !this.isConnected || controller.signal.aborted) return;
          this.loaded = true;
          this.removeAttribute('data-url');
          if (!replacement.querySelector('.related-grid')) return;
          this.replaceChildren(...Array.from(replacement.childNodes, node => document.importNode(node, true)));
          this.dispatchEvent(new CustomEvent('tone:content-updated', {bubbles: true, detail: {sectionId: this.dataset.sectionId}}));
        } catch (error) {
          if (error.name !== 'AbortError') this.dataset.recommendationsUnavailable = 'true';
        } finally { this.loading = false; }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.loading = false;
      }
    });
  }
  if (!customElements.get('tone-content-gift-card')) {
    customElements.define('tone-content-gift-card', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.querySelector('[data-gift-actions]')?.removeAttribute('hidden');
        this.addEventListener('click', async event => {
          if (event.target.closest('[data-print]')) window.print();
          if (!event.target.closest('[data-copy-code]')) return;
          const input = this.querySelector('[data-gift-code]');
          const status = this.querySelector('[data-copy-status]');
          if (!input || !status) return;
          try {
            await navigator.clipboard.writeText(input.value.replace(/\s/g, ''));
            if (this.isConnected) status.textContent = status.dataset.success;
          } catch {
            input.focus();
            input.select();
            status.textContent = status.dataset.error;
          }
        }, {signal: this.controller.signal});
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
})();
